import { styled } from '@mui/material/styles'
import { Button as MuiButton, ButtonProps } from '@mui/material'
import { primary } from '@/constant'

export type ConfirmButtonProps = ButtonProps;

export const ConfirmButton = styled(MuiButton, {
  shouldForwardProp: (prop) =>
    prop !== 'danger' && prop !== 'shadow' && prop !== 'highlight',
})<{
  danger?: 'true' | 'false';
  shadow?: 'true' | 'false';
  highlight?: 'true' | 'false';
}>(({ danger, shadow = 'true', highlight }) => ({
  color: danger === 'true' ? primary : '#fff',
  inlineSize: 'fit-content',
  userSelect: 'none',
  minWidth: 'auto',
  display: 'flex',
  padding: '0px 16px',
  lineHeight: '24px',
  borderRadius: '4px',
  fontSize: '14px',
  height: '36px',
  background:
    danger === 'true'
      ? 'transparent'
      : 'linear-gradient(90deg, #52C41A 0%, #11AF60 100%)',
  transition: 'all 0.2s ease-in-out',
  zIndex: 100,
  '&:hover': {
    color: highlight === 'true' ? primary : '#fff',
    ...(shadow === 'true' && {
      boxShadow:
        danger === 'true'
          ? '0px 10px 24px 0px rgba(255,31,31,0.22)'
          : '0px 10px 24px 0px rgba(82,196,26,0.5)',
    }),
    background:
      danger === 'true' && 'linear-gradient(225deg, #FF1F1F 0%, #F78900 100%)',
    transition: 'all 0.2s ease-in-out',
  },
}))
